import s1 from '@/assets/scenes/s1/sprites'
import s2 from '@/assets/scenes/s2/sprites'
import s3 from '@/assets/scenes/s3/sprites'
import s4 from '@/assets/scenes/s4/sprites'
import s5 from '@/assets/scenes/s5/sprites'
import s6 from '@/assets/scenes/s6/sprites'
import s7 from '@/assets/scenes/s7/sprites'
import s8 from '@/assets/scenes/s8/sprites'

export default {
  // 背景
  s1_sky: {
    size: {
      mode: 'heightFit',
      height: 1
    },
    position: 'center',
    anchor: 'center'
  },
  ...s8,
  ...s7,
  ...s5,
  ...s6, // 第6个场景需要覆盖第5个，所以放后面渲染
  ...s4,
  ...s3,
  ...s2,
  ...s1
}



// WEBPACK FOOTER //
// ./src/assets/sprites.js